import { faArrowLeft, faEye, faPencil, faTachometer, faTasks, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import Scroll from 'react-scroll';

import { useRecoilState } from 'recoil';
import { deleteSessionTemplateAPI, getSessionTemplateDetailAPI } from "../../API/SessionTemplate";
import { topAlertMessageState, topAlertStatusState } from "../../AppState";
import { EQUIPMENT_OPTIONS } from "../../Constants/FieldOptions";
import DataDisplayRowCheckbox from "../Reusable/DataDisplayRowCheckbox";
import DataDisplayRowText from "../Reusable/DataDisplayRowText";
import DataDisplayRowTextSessionType from "../Reusable/Detail/SessionType";
import FormMultiSelectField from "../Reusable/FormMultiSelectField";
import PageLoadingContent from "../Reusable/PageLoadingContent";


function SessionTemplateDetail() {
    ////
    //// Global state.
    ////

    const [topAlertMessage, setTopAlertMessage] = useRecoilState(topAlertMessageState);
    const [topAlertStatus, setTopAlertStatus] = useRecoilState(topAlertStatusState);

    ////
    //// URL Parameters.
    ////

    const { id } = useParams()

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [sessionTemplate, setSessionTemplate] = useState({});
    const [forceURL, setForceURL] = useState("");
    const [showDeletionConfirmationModal, setShowDeletionConfirmationModal] = useState(false);
    const [isFetching, setFetching] = useState(false);

    ////
    //// API.
    ////

    // --- Detail --- //

    function onSessionTemplateDetailSuccess(response){
        console.log("onSessionTemplateDetailSuccess: Starting...");
        setSessionTemplate(response);
    }

    function onSessionTemplateDetailError(apiErr) {
        console.log("onSessionTemplateDetailError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateDetailDone() {
        console.log("onSessionTemplateDetailDone: Starting...");
        setFetching(false);
    }

    // --- Delete --- //

    function onSessionTemplateDeleteSuccess(response){
        console.log("onSessionTemplateDeleteSuccess: Starting..."); // For debugging purposes only.

        // Update notification.
        setTopAlertStatus("success");
        setTopAlertMessage("Session template deleted");
        setTimeout(() => {
            console.log("onDeleteConfirmButtonClick: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // Upone success redirect user back to the `/users` list page.
        setForceURL("/session-templates");
    }

    function onSessionTemplateDeleteError(apiErr) {
        console.log("onSessionTemplateDeleteError: Starting..."); // For debugging purposes only.
        setErrors(apiErr);

        // Update notification.
        setTopAlertStatus("danger");
        setTopAlertMessage("Failed deleting");
        setTimeout(() => {
            console.log("onSessionTemplateDeleteError: topAlertMessage, topAlertStatus:", topAlertMessage, topAlertStatus);
            setTopAlertMessage("");
        }, 2000);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onSessionTemplateDeleteDone() {
        console.log("onSessionTemplateDeleteDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    const onDeleteConfirmButtonClick = () => {
        console.log("onDeleteConfirmButtonClick"); // For debugging purposes only.

        deleteSessionTemplateAPI(
            id,
            onSessionTemplateDeleteSuccess,
            onSessionTemplateDeleteError,
            onSessionTemplateDeleteDone
        );
        setShowDeletionConfirmationModal(false);
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.

            setFetching(true);
            getSessionTemplateDetailAPI(
                id,
                onSessionTemplateDetailSuccess,
                onSessionTemplateDetailError,
                onSessionTemplateDetailDone
            );
        }

        return () => { mounted = false; }
    }, [id]);

    ////
    //// Component rendering.
    ////

    if (forceURL !== "") {
        return <Navigate to={forceURL}  />
    }

    return (
        <>
            <div class="container">
                <section class="section">
                    {/* Desktop Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
                        <ul>
                            <li><Link to="/dashboard"><FontAwesomeIcon className="fas" icon={faTachometer} />&nbsp;Dashboard</Link></li>
                            <li class=""><Link to="/session-templates" aria-current="page"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Templates</Link></li>
                            <li class="is-active"><Link to={`/session-template`} aria-current="page"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Details</Link></li>
                        </ul>
                    </nav>

                    {/* Mobile Breadcrumbs */}
                    <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
                        <ul>
                            <li class=""><Link to={`/session-templates`} aria-current="page"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Session Templates</Link></li>
                        </ul>
                    </nav>

                    {/* Modals */}
                    <nav class="">
                        <div class={`modal ${showDeletionConfirmationModal ? 'is-active' : ''}`}>
                            <div class="modal-background"></div>
                            <div class="modal-card">
                                <header class="modal-card-head">
                                    <p class="modal-card-title">Are you sure?</p>
                                    <button class="delete" aria-label="close" onClick={(e, ses) => setShowDeletionConfirmationModal(false)}></button>
                                </header>
                                <section class="modal-card-body">
                                    You are about to delete this session template and all the data inside of it. This action is cannot be undone. Are you sure you would like to continue?
                                </section>
                                <footer class="modal-card-foot">
                                    <button class="button is-success" onClick={onDeleteConfirmButtonClick}>Confirm</button>
                                    <button class="button" onClick={(e, ses) => setShowDeletionConfirmationModal(false)}>Cancel</button>
                                </footer>
                            </div>
                        </div>
                    </nav>

                    {/* Page */}
                    <nav class="box">
                        {/* Title + Options */}
                        <div class="columns">
                            <div class="column">
                                <p class="title is-4"><FontAwesomeIcon className="fas" icon={faTasks} />&nbsp;Session Template</p>
                            </div>
                            <div class="column has-text-right">

                                <Link to={`/session-template/${id}/edit`} class="button is-small is-warning is-fullwidth-mobile" type="button">
                                    <FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Edit Session Template
                                </Link>
                                &nbsp;
                                <button onClick={(e, ses) => setShowDeletionConfirmationModal(true)} class="button is-small is-danger is-fullwidth-mobile" type="button">
                                    <FontAwesomeIcon className="mdi" icon={faTrashCan} />&nbsp;Delete Session Template
                                </button>
                            </div>
                        </div>

                        {/* Tab Navigation */}
                        <div class="tabs is-medium">
                            <ul>
                                <li>
                                    <Link class="is-active" to={`/session-template/${id}`}><strong>Detail</strong></Link>
                                </li>
                                {(() => {
                                    // Defensive code: Only run this if we have data.
                                    if (sessionTemplate !== undefined && sessionTemplate !== null && sessionTemplate !== "") {
                                        // Show based on session type.
                                        switch (sessionTemplate.sessionType) {
                                            case "base": return (
                                                <li>
                                                    <Link to={`/session-template/${id}/video-sections`}>Video Sections</Link>
                                                </li>
                                            );
                                            case "sleep": return (
                                                <li>
                                                    <Link to={`/session-template/${id}/sleep-questions`}>Sleep Questions</Link>
                                                </li>
                                            );
                                            case "breath": return (
                                                <li>
                                                    <Link to={`/session-template/${id}/breathwork-options`}>Breathing Options</Link>
                                                </li>
                                            );
                                            default: return null;
                                        };
                                    }
                                    // In case we don't have a session template.
                                    return null;
                                })()}
                            </ul>
                        </div>

                        {isFetching
                            ?
                            <PageLoadingContent displayMessage={"Please wait"} />
                            :
                            <>
                                {sessionTemplate && <div class="columns">
                                    <div class="column">
                                        <p class="subtitle"><FontAwesomeIcon className="fas" icon={faEye} />&nbsp;Details</p>
                                        <DataDisplayRowText
                                            label="ID"
                                            name="id"
                                            placeholder="Text input"
                                            value={sessionTemplate.id}
                                            maxWidth="260px"
                                            disabled={true}
                                        />

                                        <DataDisplayRowText
                                            label="Created"
                                            placeholder="0 or 1"
                                            value={sessionTemplate.created}
                                        />

                                        <DataDisplayRowText
                                            label="User ID (Optional)"
                                            placeholder="Number"
                                            value={sessionTemplate.userID}
                                        />

                                        <DataDisplayRowText
                                            label="No"
                                            value={sessionTemplate.no}
                                        />

                                        <DataDisplayRowText
                                            label="Completed Time (Optional)"
                                            value={sessionTemplate.completedTime}
                                        />

                                        <DataDisplayRowText
                                            label="Duration (Optional)"
                                            value={sessionTemplate.duration}
                                        />

                                        <DataDisplayRowText
                                            label="Total Duration (Optional)"
                                            value={sessionTemplate.totalDuration}
                                        />

                                        <DataDisplayRowText
                                            label="Name"
                                            value={sessionTemplate.name}
                                        />

                                        <DataDisplayRowText
                                            label="Description (Optional)"
                                            value={sessionTemplate.description}
                                        />

                                        <DataDisplayRowText
                                            label="Brief (Optional)"
                                            value={sessionTemplate.brief}
                                        />

                                        <FormMultiSelectField
                                            label="Equipment (Optional)"
                                            name="equipment"
                                            placeholder="Text input"
                                            options={EQUIPMENT_OPTIONS}
                                            selectedValues={sessionTemplate.equipment}
                                            helpText="Pick the equipment associated with this session template."
                                            maxWidth="320px"
                                            disabled={true}
                                        />

                                        <DataDisplayRowText
                                            label="Target Heart Rate Ratio (Optional)"
                                            type="number"
                                            value={sessionTemplate.targetHeartRateRatio}
                                        />

                                        <DataDisplayRowTextSessionType
                                            label="Session Type"
                                            value={sessionTemplate.sessionType}
                                        />

                                        <DataDisplayRowCheckbox
                                            label="Is primary session?"
                                            checked={sessionTemplate.isPrimarySession}
                                        />

                                        <div class="columns">
                                            <div class="column is-half">
                                                <Link to="/session-templates" class="button is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faArrowLeft} />&nbsp;Back to Session Templates</Link>
                                            </div>
                                            <div class="column is-half has-text-right">
                                                <Link to={`/session-template/${id}/edit`} class="button is-warning is-fullwidth-mobile"><FontAwesomeIcon className="fas" icon={faPencil} />&nbsp;Edit</Link>
                                            </div>
                                        </div>
                                    </div>

                                </div>}
                            </>
                        }
                    </nav>
                </section>
            </div>
        </>
    );
}

export default SessionTemplateDetail;
